(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/debug-tools/assets/javascripts/debug-tools.js') >= 0) return;  svs.modules.push('/components/casino-react/debug-tools/assets/javascripts/debug-tools.js');
'use strict';

const CardType = svs.components.casino_react.common.constants.CardType;
const AddBrokenItemToLastSearched = svs.components.casino_react.debug_tools.components.AddBrokenItemToLastSearched;
const DebugTools = () => {
  if (!svs.core.detect.feature('ft-casino-debug-tools')) {
    return null;
  }
  return React.createElement("div", {
    className: "casino-debug-tools"
  }, React.createElement("h2", {
    className: "h2 casino-debug-tools__header"
  }, "Debug tools"), React.createElement(AddBrokenItemToLastSearched, {
    type: CardType.GAME
  }), React.createElement(AddBrokenItemToLastSearched, {
    type: CardType.PROVIDER
  }));
};
setGlobal('svs.components.casino_react.debug_tools.DebugTools', DebugTools);

 })(window);